import React, { useState, useEffect } from "react";

import { Mensaje } from "../mensajes2";
import { Dimmer } from "../spinner";

import useTable from "../useTable";
import axios from "axios";
import { Toasts } from "../toasts";
//import { ActualizarUsuario } from './modalUsuarioPresu';
import { CambiarClave } from "../comun/modalCambiarClave";
import { ActualizarUsuarioGeneral } from "../modalesGenerales/modalUsuario";

function TablaUsuarioPresu(props) {
  let token = localStorage.getItem("jwtToken");
  let op = require("../../../src/modulos/datos");

  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [espiritu, setEspiritu] = useState(localStorage.getItem("espiritu"));
  const [fechaSistema, setFechaSistema] = useState(
    localStorage.getItem("fechasistema"),
  );
  const [activate, setActivate] = useState(false);
  const [mostrar, setMostrar] = useState(false);
  const [mostrar5, setMostrar5] = useState(false);
  const [idUsuarioH, setIdUsuarioH] = useState(0);
  const [persona, setPersona] = useState();
  const [usuarioH, setUsuarioH] = useState();
  const [idUsuario, setIdUsuario] = useState();
  const [usuariow, setUsuariow] = useState();
  const [mostrar2, setMostrar2] = useState(false);
  const [credito, setCredito] = useState();
  const [deuda, setDeuda] = useState();
  const [historico, setHistorico] = useState();
  const [anioActu, setAnioActu] = useState(localStorage.getItem("anioactu"));
  const [operacion, setOperacion] = useState();
  const [inmueble, setInmueble] = useState();
  const permiso = JSON.parse(localStorage.getItem("accusuariopresu"));
  const [permisoDecla, setPermisoDecla] = useState();
  const [permisoExon, setPermisoExon] = useState();
  const [records, setRecords] = useState([]);
  const [sigue, setSigue] = useState(false);
  const [toast, setToast] = useState({
    mostrar: false,
    mensaje: "",
    titulo: "",
  });
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [configCome, setConfigCome] = useState();

  console.log("permiso usuario: " + permiso);

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const headCells = [
    {
      id: "idinmueble",
      label: "CODIGO",
      width: "10px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "numficha",
      label: "USUARIO",
      width: "70px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "nombrepropie",
      label: "NOMBRES",
      width: "250px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "dirinmueble",
      label: "OPCIONES",
      width: "250px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
  ];

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.idusuario.includes(target.value) ||
              x.login.toLowerCase().includes(target.value.toLowerCase()) ||
              (x.nombres + " " + x.apellidos)
                .toLowerCase()
                .includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  const renderizar = () => {
    setMostrar5(false);
    setPersona();
    setUsuarioH();
    seleccionarUsuarios();
  };

  useEffect(() => {
    let obj = JSON.parse(localStorage.getItem("post"));
    setFechaSistema(obj.fechasistema);
    setEspiritu(obj.espiritu);
    seleccionarUsuarios();
  }, []);

  const cerrarToast = () => {
    setToast({
      ...toast,
      mostrar: false,
    });
  };

  const seleccionarUsuarios = () => {
    setActivate(true);

    let endpoint = op.conexion + `/api/presupuesto/modulouser`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status == 200) {
          if (response.data.length > 0) {
            console.log(response.data);
            setRecords(response.data);

            setActivate(false);
          } else {
            setRecords([]);
          }
        }

        setActivate(false);
      })
      .catch((error) => {
        setActivate(false);
      });
    //selectUsu();
  };

  const gestionarUsuario = (index, op, per) => (event) => {
    event.preventDefault();
    setOperacion(op);
    if (per.toString() === "1") {
      if (op === 1) {
        setMostrar5(true);
      } else {
        console.log(index);

        setIdUsuarioH(index.idusuario);

        setActivate(true);

        setPersona({
          cedula: index.cedula,
          nombres: index.nombres,
          apellidos: index.apellidos,
          correoe: index.correoe,
          tlf1: index.tlf1,
          tlf2: index.tlf2,
          fnacimiento: index.fnacimiento,
          nacionalidad: index.nacionalidad,
          sexo: index.sexo,
          direccion: index.direccion,
        });
        setUsuarioH(index);
        setMostrar5(true);
        setActivate(false);
      }
    } else {
      setToast({
        mostrar: true,
        mensaje:
          op === 1
            ? "No posee permiso para Registrar"
            : op === 2
              ? "No posee permiso para Editar"
              : op === 3
                ? "No posee permiso para Eliminar"
                : "No posee permiso para Consultar",
        titulo: "Alerta.",
      });
    }
  };

  const cerrarModalActualizar = () => {
    setUsuarioH();
    setUsuariow();
    setPersona();
    setMostrar5(false);
  };

  const validarActuUsuario = () => {
    if (operacion === 4) {
      setUsuarioH();
      setMostrar5(false);
      return;
    }
    if (operacion === 1) {
      setIdUsuarioH(0);
    }

    setUsuarioH();
    setUsuariow();
    setPersona();
    setMostrar5(false);
    window.location.href = "/usuariosHacienda";
  };

  const cambiarClave = () => {
    setMostrar2(true);
  };

  const handleCloseClave = () => {
    setMostrar2(false);
  };

  const cerrar = () => {
    props.menu();
  };

  const permisosConfigPresupuesto = [
    // --- TAB: FORMULACIÓN PRESUPUESTARIA ---
    {
      label: "Categoria Programaticas",
      key: "acccatpro",
      type: "radio",
      tab: "Formulacion",
      valor: "0",
    },
    {
      label: "Clasificador Presupuestario",
      key: "accpuc",
      type: "radio",
      tab: "Formulacion",
      valor: "0",
    },
    {
      label: "Ejercicios Físcal",
      key: "accefiscal",
      type: "check",
      tab: "Formulacion",
      valor: "0000",
    },
    {
      label: "Aprobar Presupuesto",
      key: "accaprobpresup",
      type: "radio",
      tab: "Formulacion",
      valor: "0",
    },
    {
      label: "Formular Presupuesto",
      key: "accformpresu",
      type: "radio",
      tab: "Formulacion",
      valor: "0",
    },

    // --- TAB: EJECUCIÓN PRESUPUESTARIA ---
    {
      label: "Partidas Extras Aprobadas",
      key: "accpartext",
      type: "radio",
      tab: "Ejecucion",
      valor: "0",
    },
    {
      label: "Aumento de Partidas/Credito Adicional",
      key: "accaumentopart",
      type: "radio",
      tab: "Ejecucion",
      valor: "0",
    },
    {
      label: "Disminución de Partidas",
      key: "accdisminucionpart",
      type: "radio",
      tab: "Ejecucion",
      valor: "0",
    },
    {
      label: "Traslados de Partidas",
      key: "acctraslado",
      type: "radio",
      tab: "Ejecucion",
      valor: "0",
    },
    {
      label: "Compromisos",
      key: "acccompromiso",
      type: "radio",
      tab: "Ejecucion",
      valor: "0",
    },
    {
      label: "Aprobaciones",
      key: "accaprocompro",
      type: "radio",
      tab: "Ejecucion",
      valor: "0",
    },

    // --- TAB: REPORTES ---
    {
      label: "Clasificador Presupuestario",
      key: "accreppuc",
      type: "radio",
      tab: "Reportes",
      valor: "0",
    },
    {
      label: "Formulación Presupuestaria",
      key: "accrepformpresu",
      type: "radio",
      tab: "Reportes",
      valor: "0",
    },
    {
      label: "Presupuesto de Ingreso",
      key: "accreppresuing",
      type: "radio",
      tab: "Reportes",
      valor: "0",
    },
    {
      label: "Estados Financieros de Gastos",
      key: "accrepedofinanc",
      type: "radio",
      tab: "Reportes",
      valor: "0",
    },
    {
      label: "Estado Financiero Mensual Gastos",
      key: "accrepcondicpar",
      type: "radio",
      tab: "Reportes",
      valor: "0",
    },
    {
      label: "Movimientos del Presupuesto",
      key: "accrepmovpresu",
      type: "radio",
      tab: "Reportes",
      valor: "0",
    },
    {
      label: "Compromisos(Ord.de Compra, Servi.,...)",
      key: "accrepcomprom",
      type: "radio",
      tab: "Reportes",
      valor: "0",
    },

    // --- TAB: CONFIGURACIÓN ---
    {
      label: "Usuarios",
      key: "accusuariopresu",
      type: "check",
      tab: "Configuracion",
      valor: "0000",
    },
    /* {
      label: "Actualización de Cargos",
      key: "acccargos",
      type: "radio",
      tab: "Configuracion",
      valor: "0",
    },
    {
      label: "Actualización de Activos",
      key: "accactivos",
      type: "radio",
      tab: "Configuracion",
      valor: "0",
    }, */
    {
      label: "Supervisor Presupuesto",
      key: "superpresu",
      type: "check",
      tab: "Configuracion",
      valor: "0",
    },
  ];
  const tabsConfigPresupuesto = [
    {
      id: "tab-datos",
      label: "Usuario",
      type: "static",
      colorClass: "bg-blue-100 text-dark text-uppercase fw-bold",
      contentId: "content-datos",
    },
    {
      id: "tab-permisos",
      label: "Permisos de Aplicaciones",
      type: "dynamic",
      colorClass: "bg-blue-200 text-dark text-uppercase fw-bold",
      contentId: "content-permisos",
      subTabs: [
        {
          id: "sub-formulacion",
          label: "Formulación Presupuestaria",
          filterValue: "Formulacion",
          colorClass: "bg-blue-100 text-dark text-uppercase fw-bold",
        },
        {
          id: "sub-ejecucion",
          label: "Ejecución Presupuestaria",
          filterValue: "Ejecucion",
          colorClass: "bg-blue-200 text-dark text-uppercase fw-bold",
        },
        {
          id: "sub-reportes",
          label: "Reportes",
          filterValue: "Reportes",
          colorClass: "bg-blue-300 text-dark text-uppercase fw-bold",
        },
        {
          id: "sub-config",
          label: "Configuración",
          filterValue: "Configuracion",
          colorClass: "bg-blue-400 text-dark text-uppercase fw-bold",
        },
      ],
    },
  ];

  return (
    <section className="modal-azulGradiant mx-auto col-9">
      <header className="header-azulGradiant">
        <h3>Usuarios</h3>
        <a type="button" onClick={cerrar}>
          salir<i className="fas fa-times"></i>
        </a>
      </header>
      <div className="form-azulGradiant px-2">
        <input
          className="search-input form-control col-md-4 form-control-sm rounded-pill mr-sm-2"
          style={{ border: "1px solid #007bff" }}
          type="search"
          placeholder="Buscar"
          onChange={handleSearch}
          aria-label="Search"
        />
        <button
          disabled={
            permiso &&
            permiso.substring(1, 2) !== "1" &&
            permiso.substring(2, 3) !== "1"
          }
          onClick={cambiarClave}
          style={{ marginBottom: "10px" }}
          className="btn btn-sm btn-primary rounded-pill ml-auto"
        >
          <i className="fas fa-key"> Cambiar Clave</i>{" "}
        </button>

        <button
          onClick={gestionarUsuario("", 1, permiso.toString().substring(1, 2))}
          style={{ marginBottom: "10px" }}
          title="Agregar Contribuyente"
          className={
            permiso.toString().substring(1, 2) === "1"
              ? "btn btn-sm btn-primary rounded-pill"
              : "btn btn-sm btn-secondary rounded-pill"
          }
        >
          <i className="fas fa-plus"> </i>{" "}
        </button>
      </div>
      <div className="col-md-12 m-0">
        <TblContainer>
          <TblHead />

          <tbody>
            {records &&
              recordsAfterPagingAndSorting().map((item, index) => (
                <tr key={item.idusuario} style={{ padding: "0" }}>
                  <td
                    className="align-baseline"
                    style={{
                      fontSize: "10px",
                      textAlign: "center",
                      //  width: "10px",
                    }}
                  >
                    {item.idusuario}
                  </td>
                  <td
                    className="align-baseline"
                    style={{
                      fontSize: "10px",
                      textAlign: "center",
                      //width: "70px",
                    }}
                  >
                    {item.login}
                  </td>
                  <td
                    className="align-baseline"
                    style={{
                      fontSize: "10px",
                      textAlign: "center",
                      //width: "250px",
                    }}
                  >
                    {item.nombres}
                  </td>

                  <td
                    align="center"
                    className="align-baseline"
                    style={{
                      fontSize: "10px",
                      textAlign: "center",
                      width: "180px",
                      padding: 0,
                    }}
                  >
                    <button
                      onClick={gestionarUsuario(
                        item,
                        4,
                        permiso.toString().substring(0, 1),
                      )}
                      className={
                        permiso.toString().substring(0, 1) === "1"
                          ? "btn btn-sm btn-info rounded-circle"
                          : "btn btn-sm btn-secondary rounded-circle"
                      }
                    >
                      <i className="fas fa-eye"></i>{" "}
                    </button>
                    <a> &nbsp; </a>
                    <button
                      onClick={gestionarUsuario(
                        item,
                        2,
                        permiso.toString().substring(2, 3),
                      )}
                      className={
                        permiso.toString().substring(2, 3) === "1"
                          ? "btn btn-sm btn-warning rounded-circle"
                          : "btn btn-sm btn-secondary rounded-circle"
                      }
                    >
                      <i className="fa fa-edit"></i>{" "}
                    </button>
                    <a> &nbsp; </a>
                    <button
                      onClick={gestionarUsuario(
                        item,
                        3,
                        permiso.toString().substring(3, 4),
                      )}
                      className={
                        permiso.toString().substring(3, 4) === "1"
                          ? "btn btn-sm btn-danger rounded-circle"
                          : "btn btn-sm btn-secondary rounded-circle"
                      }
                    >
                      <i className="fa fa-trash-alt"></i>{" "}
                    </button>
                  </td>
                </tr>
              ))}
          </tbody>
        </TblContainer>
        <TblPagination />
      </div>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />

      <Dimmer active={activate} inverted></Dimmer>

      <CambiarClave show={mostrar2} onHide={handleCloseClave} />

      {/* /.card-header */}

      <Toasts
        show={toast.mostrar}
        titulo={toast.titulo}
        mensaje={toast.mensaje}
        onHideCancela={cerrarToast}
      />

      <ActualizarUsuarioGeneral
        show={mostrar5} /* titulo={titulo1} */ /* mensaje={msg1} */
        onHideCancela={cerrarModalActualizar}
        onHideAcepta={validarActuUsuario}
        usuario={usuarioH}
        datospersonales={persona}
        deshabilitado={deshabilitado ? deshabilitado : undefined}
        ingresa={0}
        declaweb={configCome ? configCome[0].declaweb.toString() : "false"}
        idusuario={idUsuario}
        operacion={operacion}
        render={renderizar}
        permisosConfig={permisosConfigPresupuesto} // Pasas el array de permisos
        tabsConfig={tabsConfigPresupuesto}
      />
    </section>
  );
}

export default TablaUsuarioPresu;
